import { user } from "../stores/userStore";
import { serverlessRoutes } from "./constants";
import { getWithJwt, postWithJwt } from "./requests";
import { storage } from "./storage";
import { errorTracker } from "./errorTracker";

export const fetchUser = async () => {
  const url = serverlessRoutes.USER;
  try {
    const fetchedUser = await getWithJwt(url);
    user.set(fetchedUser);
    await storage.set("role", fetchedUser.roleId);

    if (
      !fetchedUser.avatarUrl?.includes("imagedelivery") &&
      fetchedUser.hash &&
      fetchedUser.fileableId
    ) { // ZA AVATAR MIGRACIJU
      postWithJwt(`${serverlessRoutes.FILE}/migrate-s3-avatar`)
        .then((response) => {
          if (response.error) { return; }

          user.update((store) => {
            store.avatarUrl = response.data.avatarUrl;
            store.hash = null;
            store.fileableId = null;

            return store;
          });

          fetchedUser.avatarUrl = response.data.avatarUrl;
          fetchedUser.hash = null;
          fetchedUser.fileableId = null;
        });
    }


    return fetchedUser;
  } catch (err) {}
};

export const refreshToken = async (): Promise<boolean> => {
  const url = `${serverlessRoutes.USER}/refresh-token`;
  try {
    const result = await getWithJwt(url);

    if (result?.accessToken) {
      await storage.set("authJwt", result.accessToken);
      return true;
    } else {
      // ✅ ERROR VISIBILITY FIX: Log when no access token is received
      console.error('Token refresh failed: No access token received from server');
      errorTracker.captureError(new Error('Token refresh failed: No access token in response'), 'warning', {
        context: 'token_refresh_no_token',
        response: result
      });
      return false;
    }
  } catch (err) {
    // ✅ ERROR VISIBILITY FIX: Proper error logging and tracking
    console.error('Token refresh failed:', err);
    errorTracker.captureError(err as Error, 'error', {
      context: 'token_refresh_api_error',
      url
    });
    return false;
  }
};
